import React from "react";
import { Link, useHistory } from "react-router-dom";
import "antd/dist/antd.min.css";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import Host from "../../Components/Host";
import { useGetUserDataQuery } from "../../services/login";

// Update these to your real profile URLs.
const SOCIAL_LINKS = [
  { name: "Instagram", url: "https://www.instagram.com/luxuracart.official" },
  { name: "Facebook", url: "https://www.facebook.com/luxuracart/" },
  // { name: "TikTok", url: "https://tiktok.com/@luxuracart" },
  // { name: "X", url: "https://x.com/luxuracart" },
  // { name: "YouTube", url: "https://youtube.com/@luxuracart" },
];

function SocialIcon({ name }) {
  switch (name) {
    case "Instagram":
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.2c3.2 0 3.6 0 4.9.07 1.2.06 1.9.24 2.4.4a4.8 4.8 0 0 1 1.7 1.1 4.8 4.8 0 0 1 1.1 1.7c.16.5.34 1.2.4 2.4.06 1.3.07 1.7.07 4.9s0 3.6-.07 4.9c-.06 1.2-.24 1.9-.4 2.4a4.8 4.8 0 0 1-1.1 1.7 4.8 4.8 0 0 1-1.7 1.1c-.5.16-1.2.34-2.4.4-1.3.06-1.7.07-4.9.07s-3.6 0-4.9-.07c-1.2-.06-1.9-.24-2.4-.4a4.8 4.8 0 0 1-1.7-1.1 4.8 4.8 0 0 1-1.1-1.7c-.16-.5-.34-1.2-.4-2.4C2.2 15.6 2.2 15.2 2.2 12s0-3.6.07-4.9c.06-1.2.24-1.9.4-2.4a4.8 4.8 0 0 1 1.1-1.7 4.8 4.8 0 0 1 1.7-1.1c.5-.16 1.2-.34 2.4-.4C8.4 2.2 8.8 2.2 12 2.2zm0 1.8c-3.15 0-3.52 0-4.76.07-.98.05-1.5.2-1.86.34-.47.18-.8.4-1.15.75-.35.35-.57.68-.75 1.15-.14.36-.3.88-.34 1.86C3.02 8.48 3 8.85 3 12s0 3.52.07 4.76c.05.98.2 1.5.34 1.86.18.47.4.8.75 1.15.35.35.68.57 1.15.75.36.14.88.3 1.86.34C7.48 20.98 7.85 21 12 21s3.52 0 4.76-.07c.98-.05 1.5-.2 1.86-.34.47-.18.8-.4 1.15-.75.35-.35.57-.68.75-1.15.14-.36.3-.88.34-1.86.06-1.24.07-1.61.07-4.76s0-3.52-.07-4.76c-.05-.98-.2-1.5-.34-1.86a3 3 0 0 0-.75-1.15 3 3 0 0 0-1.15-.75c-.36-.14-.88-.3-1.86-.34C15.52 4 15.15 4 12 4zm0 3.6a4.4 4.4 0 1 1 0 8.8 4.4 4.4 0 0 1 0-8.8zm0 1.8a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2zm4.6-2a1.03 1.03 0 1 1 0 2.06 1.03 1.03 0 0 1 0-2.06z" />
        </svg>
      );
    case "Facebook":
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M14 9h3V6h-3c-1.9 0-3.5 1.6-3.5 3.5V11H8v3h2.5v6h3v-6H16l.5-3h-3V9.5c0-.3.2-.5.5-.5z" />
        </svg>
      );
    case "TikTok":
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M16.6 3c.4 2 1.7 3.4 3.7 3.6v2.7c-1.3.1-2.5-.3-3.7-1.1v6.8c0 3-2.4 5.4-5.4 5.4S5.8 17.9 5.8 15c0-2.9 2.2-5.2 5.1-5.4v2.8a2.6 2.6 0 1 0 2.2 2.6V3h3.5z" />
        </svg>
      );
    case "X":
      return (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.9 3H22l-7.2 8.2L23 21h-6.8l-5.3-6.5L4.8 21H1.7l7.7-8.8L1 3h7l4.8 5.9L18.9 3zm-1.2 16h1.9L7.4 5H5.4l12.3 14z" />
        </svg>
      );
    case "YouTube":
      return (
        <svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor">
          <path d="M23 12s0-3.3-.4-4.8a3 3 0 0 0-2.1-2.1C19 4.6 12 4.6 12 4.6s-7 0-8.5.5a3 3 0 0 0-2.1 2.1C1 8.7 1 12 1 12s0 3.3.4 4.8a3 3 0 0 0 2.1 2.1c1.5.5 8.5.5 8.5.5s7 0 8.5-.5a3 3 0 0 0 2.1-2.1c.4-1.5.4-4.8.4-4.8zM9.7 15.3V8.7l6 3.3-6 3.3z" />
        </svg>
      );
    default:
      return null;
  }
}

function Footer() {
  const { userId, userToken, countryCode } = useSelector((state) => state.auth);
  const { t } = useTranslation();

  const { data: userData } = useGetUserDataQuery(
    { userId, userToken, countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  return (
    <div className="Footer-page">
      <div className="Footer-menu-card1">
        <div className="container">
          <div className="Footer-menu-card fp-mp">
            <div className="Footer-menu-item footer-categories">
              <h5 className="footer-title-1">{t("Collections")}</h5>
              <div className="Footer-menu-SubItem">
                <Link to="/search/Health & Personal Care">{t("Health & Personal Care")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/search/Baby & Mom">{t("Baby & Mom")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/search/Beauty & Cosmetics">{t("Beauty & Cosmetics")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/search/Lifestyle & Sports">{t("Lifestyle & Sports")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/search/Gadgets & Electronics">{t("Gadgets & Electronics")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/search/Home & Kitchen">{t("Home & Kitchen")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/search/Pet Supplies">{t("Pet Supplies")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/search/TGG Prime">{t("TGG Prime")}</Link>
              </div>
            </div>

            <div className="Footer-menu-item">
              <h5 className="footer-title-1">{t("Quick Links")}</h5>
              <div className="Footer-menu-SubItem">
                <Link to="/about-us">{t("About us")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/contact-us">{t("Contact Information")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/careers">{t("careers")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/faqs">{t("faqs")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/track-order">{t("track_order")}</Link>
              </div>
            </div>

            <div className="Footer-menu-item">
              <h5 className="footer-title-1">{t("Legal")}</h5>
              <div className="Footer-menu-SubItem">
                <Link to="/shipping-policy">{t("shipping_policy")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/payment-policy">{t("payment_policy")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/returns-and-refund">{t("return_refunds")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/privacy-policy">{t("privacy_policy")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/terms-and-conditions">{t("terms_and_conditions")}</Link>
              </div>
            </div>

            <div className="Footer-menu-item">
              <h5 className="footer-title-1">{t("contact")}</h5>
              <div className="Footer-menu-SubItem">
                <div className="footer-address">
                  <div dangerouslySetInnerHTML={{ __html: Host?.address }}></div>
                  <div className="footer-email">
                    <MailOutlineIcon style={{ fontSize: "1.05rem" }} />
                    <span>{Host?.email}</span>
                  </div>
                </div>
              </div>

              <div className="footer-social">
                <span className="footer-social__label">{t("follow_us")}</span>
                <div className="footer-social__icons">
                  {SOCIAL_LINKS.map((s) => (
                    <a
                      key={s.name}
                      href={s.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={s.name}
                      className="footer-social__icon"
                    >
                      <SocialIcon name={s.name} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="Footer-menu-card Footer-menu-card--bottom">
            <div className="Footer-menu-item Footer-menu-bottom">
              <div className="Footer-menu-subcard">
                <div className="Footer-menu-SubItem">
                  © {new Date().getFullYear()} Luxura Ventures LLC | {t("all_right_reserved")}
                </div>
                <div className="Footer-menu-SubItem">
                  <div className="footer-payments">
                    <span className="footer-payments__icon">
                      <svg width="30px" viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg">
                        <g fill="none" fillRule="evenodd">
                          <rect stroke="#000" strokeOpacity="0.2" strokeWidth="0.5" fill="#FFF" x="0.25" y="0.25" width="23.5" height="15.5" rx="2" />
                          <path
                            d="M2.79 5.91C2.26 5.63 1.67 5.4 1 5.24l.03-.13h2.74c.37.01.68.13.78.52l.59 2.84.18.85 1.67-4.19h1.8L6.1 11.28H4.3L2.79 5.91zM10.1 11.28H8.4l1.06-6.17h1.7L10.1 11.28zM16.27 5.26l-.23 1.33-.15-.06c-.31-.13-.72-.25-1.27-.24-.67 0-.97.27-.98.54 0 .29.37.48.93.76.98.44 1.44.98 1.43 1.68-.01 1.28-1.17 2.11-2.96 2.11-.76-.01-1.5-.16-1.9-.34l.24-1.38.22.1c.55.23.92.33 1.6.33.49 0 1.01-.19 1.02-.6 0-.27-.22-.47-.88-.77-.64-.3-1.5-.79-1.49-1.68.01-1.2 1.19-2.04 2.87-2.04.66 0 1.19.14 1.52.26zM18.53 9.1h1.41c-.07-.31-.39-1.79-.39-1.79l-.12-.53c-.08.23-.23.61-.22.6 0 0-.54 1.37-.68 1.72zM20.63 5.11L22 11.28h-1.58s-.15-.71-.2-.93h-2.18c-.06.16-.36.93-.36.93h-1.79l2.53-5.66c.17-.4.48-.51.89-.51h1.32z"
                            fill="#1434CB"
                          />
                        </g>
                      </svg>
                    </span>
                    <span className="footer-payments__icon">
                      <svg viewBox="0 0 24 16" width="29px" xmlns="http://www.w3.org/2000/svg">
                        <g fill="none" fillRule="evenodd">
                          <rect fill="#252525" height="16" rx="2" width="24" />
                          <circle cx="9" cy="8" fill="#eb001b" r="5" />
                          <circle cx="15" cy="8" fill="#f79e1b" r="5" />
                          <path
                            d="m12 3.99963381c1.2144467.91220633 2 2.36454836 2 4.00036619s-.7855533 3.0881599-2 4.0003662c-1.2144467-.9122063-2-2.36454837-2-4.0003662s.7855533-3.08815986 2-4.00036619z"
                            fill="#ff5f00"
                          />
                        </g>
                      </svg>
                    </span>
                    <span className="footer-payments__icon">
                      <svg width="30px" viewBox="0 -11 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9" />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M33.06 31.52V25.47H36.18C37.46 25.47 38.53 25.05 39.41 24.2L39.63 23.99C41.23 22.24 41.13 19.52 39.41 17.9C38.56 17.04 37.39 16.58 36.18 16.6H31.17V31.52H33.06ZM33.06 23.64V18.43H36.23C36.91 18.43 37.55 18.69 38.03 19.17C39.05 20.17 39.08 21.83 38.09 22.87C37.61 23.38 36.93 23.67 36.23 23.64H33.06Z"
                          fill="#3C4043"
                        />
                        <path d="M26.54 24.17C26.54 23.58 26.5 23 26.4 22.43H18.44V25.72H23.00C22.82 26.78 22.21 27.73 21.32 28.33V30.47H24.04C25.63 28.98 26.54 26.78 26.54 24.17Z" fill="#4285F4" />
                        <path d="M18.44 32.54C20.72 32.54 22.64 31.78 24.04 30.47L21.32 28.33C20.55 28.85 19.58 29.15 18.44 29.15C16.24 29.15 14.38 27.64 13.71 25.62H10.91V27.83C12.34 30.72 15.26 32.54 18.44 32.54Z" fill="#34A853" />
                        <path d="M13.71 25.62C13.36 24.56 13.36 23.40 13.71 22.33V20.13H10.91C9.70 22.55 9.70 25.40 10.91 27.82L13.71 25.62Z" fill="#FBBC04" />
                        <path d="M18.44 18.80C19.65 18.78 20.81 19.24 21.68 20.09L24.09 17.64C22.56 16.19 20.54 15.39 18.44 15.41C15.26 15.41 12.34 17.24 10.91 20.13L13.71 22.35C14.38 20.31 16.24 18.80 18.44 18.80Z" fill="#EA4335" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div className="Footer-menu-subcard">
                <div className="Footer-menu-SubItem">
                  <div className="footer-locale">
                    <span>{t("country")}: </span>
                    <img
                      loading="lazy"
                      width="20"
                      src={`https://flagcdn.com/w20/${countryCode?.toLowerCase()}.png`}
                      srcSet={`https://flagcdn.com/w40/${countryCode?.toLowerCase()}.png 2x`}
                      alt=""
                    />
                    <span>{userData?.contant?.country}</span>
                  </div>
                </div>
                <div className="Footer-menu-SubItem">
                  <div className="footer-locale">
                    <span>{t("currency")}: </span>
                    <span>{userData?.contant?.currency}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;